function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { TfnrAuthContext } from './TfnrAuthContext';
import { tfnrRefreshTokenHof } from './tfnrRefreshTokenHof';

var TfnrAuthProvider = function TfnrAuthProvider(_ref) {
  var children = _ref.children,
      onAuthUpdate = _ref.onAuthUpdate,
      tfnrApiUrl = _ref.tfnrApiUrl;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      viewInfo = _useState2[0],
      setViewInfo = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      loginTime = _useState4[0],
      setLoginTime = _useState4[1]; // Only logs out the UI; doesn't invalidate token so this should only be used after token is invalidated/expired


  var logout = function logout() {
    localStorage.removeItem('view_info');
    setViewInfo({});
    localStorage.removeItem('loginTime');
    setLoginTime(null);
  }; // call onAuthUpdate when auth info updates


  useEffect(function () {
    if (onAuthUpdate) {
      onAuthUpdate(viewInfo);
    }
  }, [onAuthUpdate, viewInfo]); // Load auth info from localStorage on app start; log out if token is expired

  useEffect(function () {
    var storedViewInfo = JSON.parse(localStorage.getItem('view_info'));
    var storedLoginTime = JSON.parse(localStorage.getItem('loginTime'));

    if (storedViewInfo && storedLoginTime) {
      var tokenExpiration = storedLoginTime + storedViewInfo.expiresIn * 1000;
      var now = Date.now();

      if (now > tokenExpiration) {
        logout();
      } else {
        setViewInfo(storedViewInfo);
        setLoginTime(storedLoginTime);
      }
    } else {
      logout();
    }
  }, []); // When the oauthToken changes, set axios to send new token in auth header

  useEffect(function () {
    if (viewInfo.oauthToken) {
      axios.defaults.headers.common.Authorization = "Bearer ".concat(viewInfo.oauthToken);
    } else {
      delete axios.defaults.headers.common.Authorization;
    }
  }, [viewInfo]); // Refresh the oauth token a few minutes before it expires if this window is active

  useEffect(function () {
    var refreshToken = tfnrRefreshTokenHof({
      viewInfo: viewInfo,
      setViewInfo: setViewInfo,
      setLoginTime: setLoginTime,
      logout: logout,
      tfnrApiUrl: tfnrApiUrl
    });
    var intervalId;

    if (viewInfo.oauthToken && loginTime) {
      var tokenExpiration = loginTime + viewInfo.expiresIn * 1000;
      var refreshBuffer = 10 * 60 * 1000;
      var refreshCheckInterval = 2 * 60 * 1000;

      var refreshCheck = function refreshCheck() {
        var now = Date.now();
        var windowActive = !document.hidden;

        if (now > tokenExpiration) {
          logout();
        } else if (windowActive && tokenExpiration - now < refreshBuffer) {
          refreshToken();
        }
      };

      intervalId = setInterval(refreshCheck, refreshCheckInterval);
    }

    return function () {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [viewInfo, loginTime]); // If tfnr updates the localStorage, update the auth data in this app as well

  var updateAuthOnStorageChange = function updateAuthOnStorageChange(e) {
    if (e.key === 'view_info') {
      setViewInfo(JSON.parse(e.newValue) || {});
    }

    if (e.key === 'loginTime') {
      setLoginTime(JSON.parse(e.newValue));
    }
  };

  useEffect(function () {
    window.addEventListener('storage', updateAuthOnStorageChange);

    var cleanup = function cleanup() {
      return window.removeEventListener('storage', updateAuthOnStorageChange);
    };

    return cleanup;
  }, []);
  return /*#__PURE__*/React.createElement(TfnrAuthContext.Provider, {
    value: {
      viewInfo: viewInfo,
      setViewInfo: setViewInfo,
      setLoginTime: setLoginTime,
      logout: logout,
      tfnrApiUrl: tfnrApiUrl
    }
  }, children);
};

TfnrAuthProvider.defaultProps = {
  onAuthUpdate: null
};
export { TfnrAuthProvider };